import React, { useState } from 'react';
import { m, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Al finalizar la compra, recibirás un correo con el enlace de descarga directa. Accedes al instante sin esperas.'
}, {
  q: '¿Es seguro el pago?',
  a: '100%. Usamos Whop, la plataforma de pago más segura en Europa. Tus datos están encriptados.'
}, {
  q: '¿Es un solo pago o hay suscripción?',
  a: 'Un solo pago. 19€ y listo. Es tuyo de por vida. Sin renovación automática.'
}, {
  q: '¿Sirve si soy principiante?',
  a: 'Totalmente. Hemos escrito esto para personas que tienen herramientas básicas (taladro, caladora, lijadora) pero no saben qué fabricar. Si sabes usar una sierra, puedes hacerlo.'
}, {
  q: '¿Puedo comprar solo algunos tomos?',
  a: 'No. El paquete es completo y diseñado para funcionar en conjunto. Pero si solo quieres algunos, escríbenos y conversamos.'
}, {
  q: '¿Qué pasa si tengo clientes de distintos presupuestos en mi zona?',
  a: 'Los 7 productos van desde 35€ a 150€. El Bono de Precios te enseña a ajustar según tu mercado local.'
}, {
  q: '¿En qué formato vienen los archivos?',
  a: 'PDF. Puedes imprimirlo, compartirlo con tu taller o llevarlo en el móvil.'
}, {
  q: '¿Hay garantía de devolución?',
  a: 'Si el producto no cumple con lo prometido, escríbenos a manualeslistos@gmail.com y te ayudaremos a resolverlo en menos de 24 horas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-44" data-mp="2td1i7c6uxdzl">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-45" data-mp="2ohm6apsets5t">
        <div className="text-center" data-id="element-46" data-mp="z138780q4e2n">
          <SectionTag icon="❓" data-id="element-47" data-mp="z25xxcmb8agz">Resolvemos tus dudas</SectionTag>
        </div>

        <div className="mt-8 space-y-3" data-id="element-48" data-mp="u31r2smuyott">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-brown/20 bg-white" data-id="element-49" data-mp="1js8ks3hb77tj" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-action" aria-expanded={isOpen} data-id="element-50" data-mp="1nu3iyz3y1533">
                  <span className="font-heading text-sm font-bold text-ink sm:text-base" data-id="element-51" data-mp="22ngpcqqufjxx">{faq.q}</span>
                  <ChevronDownIcon size={18} className={`flex-shrink-0 text-brown transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-52" data-mp="2bhld31aokf98" />
                </button>
                <AnimatePresence initial={false} data-id="element-53" data-mp="2lhlxkqkad1f0">
                  {isOpen && <m.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-54" data-mp="2qfdq9msr8rk9">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-muted" data-id="element-55" data-mp="4turt46pu9y9">{faq.a}</p>
                    </m.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}